import { render, staticRenderFns } from "./icon-plus.vue?vue&type=template&id=b2d785d8&scoped=true"
import script from "./icon-plus.vue?vue&type=script&lang=js"
export * from "./icon-plus.vue?vue&type=script&lang=js"
import style0 from "./icon-plus.vue?vue&type=style&index=0&id=b2d785d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d785d8",
  null
  
)

export default component.exports